'use client';

import { useEffect } from 'react';

// 部署後，開著舊分頁的使用者要載入的 JS chunk（hash 檔名）已被新版取代 → ChunkLoadError。
// 偵測到就自動重載新版，讓部署對開著的分頁無感（使用者不會再看到這個錯誤頁）。
// sessionStorage 時間戳當防護：距上次自動重載 <10s 就不再重載，避免真的壞掉時無限重整。
function isChunkLoadError(err: unknown): boolean {
    const e = err as { name?: string; message?: string } | undefined;
    if (!e) return false;
    if (e.name === 'ChunkLoadError') return true;
    const msg = e.message || '';
    return /Loading chunk [\d]+ failed|Loading CSS chunk|Failed to fetch dynamically imported module|error loading dynamically imported module|importing a module script failed/i.test(
        msg,
    );
}

export default function GlobalError({
    error,
}: {
    error: Error & { digest?: string };
    reset: () => void;
}) {
    useEffect(() => {
        if (isChunkLoadError(error)) {
            try {
                const KEY = '__chunk_reload_at';
                const last = Number(sessionStorage.getItem(KEY) || '0');
                if (Date.now() - last > 10000) {
                    sessionStorage.setItem(KEY, String(Date.now()));
                    window.location.reload();
                    return;
                }
            } catch {
                /* sessionStorage 不可用 → 落到顯示錯誤頁，讓使用者手動重整 */
            }
        }
        console.error('[GlobalError]', error);
    }, [error]);

    return (
        <div className="min-h-screen flex flex-col items-center justify-center gap-4 p-8 text-center">
            <h2 className="text-xl font-bold">頁面發生錯誤</h2>
            <p className="text-sm text-gray-500">
                {error.digest ? `錯誤代碼：${error.digest}` : '請稍後再試或聯繫系統管理員。'}
            </p>
            <button
                onClick={() => window.location.reload()}
                className="px-4 py-2 rounded bg-slate-700 text-white text-sm hover:bg-slate-600"
            >
                重新整理
            </button>
        </div>
    );
}
